import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostBinding, Input } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputComponent implements ControlValueAccessor {
  private static nextId = 0

  @Input() label = ''
  @Input() placeholder = ''
  @Input() type = 'text'
  @Input() icon?: IconProp
  @Input() hint = ''
  @Input() error = ''
  @Input() required = false
  @Input() readonly = false
  @Input() autocomplete?: string
  @Input() name?: string
  @Input() inputId = `app-input-${InputComponent.nextId++}`

  @HostBinding('attr.name') get hostName(): string | null {
    return this.name ?? null
  }

  value = ''
  disabled = false

  private onChange: (value: string) => void = () => {}
  private onTouched: () => void = () => {}

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string | null): void {
    this.value = value ?? ''
    this.cdr.markForCheck()
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
    this.cdr.markForCheck()
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement
    this.value = target.value
    this.onChange(this.value)
  }

  onBlur(): void {
    this.onTouched()
  }
}
